<template>
    <div class="Footer">
        <div class="LogoView">
            <img src="@/image/logo1.png" alt="">
            <img src="@/image/logo2.png" alt="">
            <img src="@/image/logo3.png" alt="">
            <img src="@/image/logo4.png" alt="">
            <img src="@/image/logo5.png" alt="">
            <img src="@/image/logo6.png" alt="">
        </div>
        <!-- <div class="ulView">
            <p>西安长安科技网站</p>
            <p>苏南智城科技网站</p>
            <p>嘉地常熟国际网站</p>
            <p>宝地嘉兴国际网站</p>
            <p>福城欧美工业园网址</p>
        </div> -->
        <div class="filings">
            中云凤凰版权所有 京公网安备:京ICP备2021034597号-3
        </div>
    </div>
</template>
<script>
export default {
    name: 'Footer',
    data() {
        return {
        }
    },
}
</script>
<style lang="scss" scoped>
.Footer {
    width: 100%;
    height: 500px;
    background-image: url('../../image/footerBack.jpg');
    background-size: 100% 100%;
    overflow: hidden;

    .LogoView {
        width: 79%;
        margin: auto;
        display: flex;
        justify-content: space-between;
        margin-top: 150px;

        img {
            width: 156px;
        }
    }

    .ulView {
        width: 79%;
        margin: auto;
        display: flex;
        height: 62px;
        border-top: 1px solid rgba(255, 255, 255, .4);
        border-bottom: 1px solid rgba(255, 255, 255, .4);
        font-size: 16px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 60px;
        justify-content: space-between;
        margin-top: 115px;
    }

    .filings {
        font-size: 16px;
        font-weight: 500;
        color: #fff;
        text-align: center;
        // margin-top: 47px;
        margin-top: 100px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Footer/footer.vue